const config = {
  cas: {
    loginUrl: "https://cas.centralesupelec.fr/cas/login",
    logoutUrl: "https://cas.centralesupelec.fr/cas/logout",
    loginService: "https://annuaire.centralesupelec.fr/loginAccept/",
    logoutService: "https://annuaire.centralesupelec.fr/"
  },
  localStorageName: "annuaire-prod",
  back: {
    url: "https://annuaire.centralesupelec.fr/api"
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/config/config-prod.js